import { render, staticRenderFns } from "./PartToggleFavorite.vue?vue&type=template&id=79539a2d"
import script from "./PartToggleFavorite.vue?vue&type=script&lang=js"
export * from "./PartToggleFavorite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports